import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "side-menu"
};
const _hoisted_2 = ["onClick"];
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'SideMenu',
  props: {
    activeId: {
      type: [String, Number],
      default: ''
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ['select'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    // 菜单点击事件
    const handleClick = item => {
      // 如果有自定义选择事件，触发事件
      if (emit) {
        emit('select', item);
      }
      // 如果有路径，进行路由跳转
      if (item.path) {
        router.push(item.path);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["menu-item", {
            active: item.id === __props.activeId
          }]),
          onClick: $event => handleClick(item)
        }, _toDisplayString(item.name || item.label), 11, _hoisted_2);
      }), 128))]);
    };
  }
});